import { Building2Icon, HandshakeIcon, UserIcon } from 'lucide-react'

import { EmployerOnboardingPage, useOnboardingStep } from 'components/hooks/employer_onboarding/useOnboardingStep'
import { authnPartnersUserRegistrations } from 'rails_routes'
import { BorderedRadioButton, RadioGroup, usePageTitle } from 'slab'
import { useWindowLocation } from 'utils/windowLocation'

import { CenteredLayout } from '../CenteredLayout'

export function GetStartedPage () {
  usePageTitle('Get Started')

  const { navigateToNextStep, navigateToStep } = useOnboardingStep()
  const { assign } = useWindowLocation()

  return (
    <CenteredLayout verticallyCentered>
      <CenteredLayout.Header
        heading='Welcome to Thatch!'
        subheading="To get started, tell us a bit about yourself and how you'll be using Thatch."
      />
      <CenteredLayout.Container hideCard padded={false}>
        <RadioGroup name='user_type' layout='horizontal' gap={4}>
          <div className='grid md:grid-cols-3 gap-4 w-full'>
            <BorderedRadioButton
              value='employer'
              label={
                <div className='flex items-center gap-2'>
                  <Building2Icon className='w-5 h-5' />
                  <span>Employer</span>
                </div>
              }
              description="You're an employer who wants to offer better health benefits for your team."
              onChange={navigateToNextStep}
              size='large'
            />
            <BorderedRadioButton
              value='employee'
              label={
                <div className='flex items-center gap-2'>
                  <UserIcon className='w-5 h-5' />
                  <span>Employee</span>
                </div>
              }
              description='You work for a company who provides health benefits through Thatch.'
              onChange={() => navigateToStep(EmployerOnboardingPage.EMPLOYEE)}
              size='large'
            />
            <BorderedRadioButton
              value='broker'
              label={
                <div className='flex items-center gap-2'>
                  <HandshakeIcon className='w-5 h-5' />
                  <span>Broker</span>
                </div>
              }
              description="You're a broker or partner who wants to help clients offer better health benefits."
              onChange={() => assign(authnPartnersUserRegistrations.new())}
              size='large'
            />
          </div>
        </RadioGroup>
      </CenteredLayout.Container>
    </CenteredLayout>
  )
}
